module.exports = __webpack_public_path__ + "static/media/ig-color.2aa9aed7.svg";